import 'whatwg-fetch';
const env = process.env;


const getHarvestSchedule = (params) => {
    	return fetch(`${env.VUE_APP_trimaster}/api/v1/ag_inFlightLifecycles/getHarvestSchedule?access_token=${params.access_token}&facility_id=${params.facility_id}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
		}
	});
}

export default {
  getHarvestSchedule
}
